import kru2uniPackage from '@anthro-ai/krutidev-unicode';

/*
 * The package is CommonJS, so depending on the bundler it may appear either
 * directly as the imported function or under `.default`.
 */
const kru2uni =
  typeof kru2uniPackage === 'function'
    ? kru2uniPackage
    : kru2uniPackage?.default;

/**
 * Convert Kruti Dev 010/011 encoded text into Unicode Devanagari.
 *
 * IMPORTANT:
 * Only call this when the source is actually Kruti Dev 010/011.
 *
 * @param {string} text
 * @returns {string}
 */
export const convertKrutiDev010ToUnicode = (text = '') => {
  if (!text) return '';

  if (typeof kru2uni !== 'function') {
    throw new Error(
      '@anthro-ai/krutidev-unicode could not be initialized'
    );
  }

  const normalizedInput = text
    .replace(/\u00A0/g, ' ')
    .replace(/\r\n/g, '\n')
    .replace(/\r/g, '\n');

  const result = kru2uni(normalizedInput);

  return String(result || '').normalize('NFC');
};